var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownSmallGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1L2.74731 2.76297C4.14075 4.1689 4.83747 4.87187 5.68667 4.98011C5.89473 5.00663 6.10527 5.00663 6.31333 4.98011C7.16252 4.87187 7.85925 4.1689 9.25269 2.76297L11 1",
    stroke: "#ACACAC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownSmallGray);
export default __webpack_public_path__ + "static/media/arrow-down-small-gray.4da9bd254e11375e31f4170e9a8bba84.svg";
export { ForwardRef as ReactComponent };